import PropTypes from 'prop-types';

import Presenter from 'utils/PropTypesPresenter';

export default new Presenter({
  displayName: PropTypes.string,
  nameInMapping: PropTypes.string,
  value: PropTypes.string,
});
